<template>
    <el-card v-loading="!is_ok" class="page_card" ref="card">
        <div
                slot="header"
                class="clearfix"
        >
            <span>用户组</span>
        </div>
        <el-row>
            <el-button type="success" plain style="margin-right: 20px;" @click="showCreateDialog">+ 新增用户组</el-button>
            <el-button-group>
                <el-button @click="changeMore(1)" :loading="is_post" :disabled="selected.length == 0"><i class="el-icon-check" /> 启用</el-button>
                <el-button @click="changeMore(0)" :loading="is_post" :disabled="selected.length == 0"><i class="el-icon-close" /> 禁用</el-button>
            </el-button-group>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table
                        empty-text="暂无数据"
                        ref="table"
                        :data="data"
                        tooltip-effect="dark"
                        style="width: 100%"
                        :max-height="tableMaxHeight"
                        @selection-change="handleSelectionChange"
                        v-if="showtable"
                        @expand-change="handleExpandChange"
                >
                    <el-table-column
                            type="selection"
                            width="55"
                    />
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <el-row>
                                <el-col :span="5" :offset="1">
                                    <el-collapse accordion>
                                        <el-collapse-item title="后台权限" name="0">
                                            <el-tree
                                                :data="allPermission0"
                                                show-checkbox
                                                :default-expand-all="false"
                                                node-key="id"
                                                ref="tree0"
                                                highlight-current
                                                :props="{children: 'children',label: 'displayName'}">
                                            </el-tree>
                                        </el-collapse-item>
                                        <el-collapse-item title="APP权限" name="1">
                                            <el-tree
                                                :data="allPermission1"
                                                show-checkbox
                                                :default-expand-all="false"
                                                node-key="id"
                                                ref="tree1"
                                                highlight-current
                                                :props="{children: 'children',label: 'displayName'}">
                                            </el-tree>
                                        </el-collapse-item>
                                        <el-collapse-item title="API权限" name="2">
                                            <el-tree
                                                :data="allPermission2"
                                                show-checkbox
                                                :default-expand-all="false"
                                                node-key="id"
                                                ref="tree2"
                                                highlight-current
                                                :props="{children: 'children',label: 'displayName'}">
                                            </el-tree>
                                        </el-collapse-item>
                                    </el-collapse>
                                    <el-button size="mini" style="margin-top: 10px" type="warning" plain @click="setPermission(scope.row)" :loading="is_post">保存设置</el-button>
                                </el-col>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column label="用户组key">
                        <template slot-scope="scope">
                            {{ scope.row.name }}
                        </template>
                    </el-table-column>
                    <el-table-column label="用户组名称">
                        <template slot-scope="scope">
                            <el-link size="mini" :type="scope.row.name == 'admin' ?'primary':'success'" :underline="false">{{ scope.row.displayName }}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column label="用户组说明">
                        <template slot-scope="scope">
                            {{ scope.row.description }}
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <el-link
                                    v-if="scope.row.isValid == 1 && scope.row.isDelete != 1"
                                    size="mini"
                                    type="success"
                                    :underline="false"
                                    @click="change(scope.row,0)"
                                    :disabled="is_post"
                            >
                                启用
                            </el-link>
                            <el-link
                                    size="mini"
                                    type="warning"
                                    :underline="false"
                                    :disabled="is_post"
                                    @click="change(scope.row,1)"
                                    v-if="scope.row.isValid == 0 && scope.row.isDelete != 1"
                            >
                                禁用
                            </el-link>
                            <el-link type="danger" size="mini" :underline="false" v-if="scope.row.isDelete == 1">已删除</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope" v-if="scope.row.name != 'admin'">
                            <el-button
                                    size="mini"
                                    type="warning"
                                    plain
                                    @click="edit(scope.row)"
                            >
                                编辑
                            </el-button>
                            <el-button
                                    size="mini"
                                    type="danger"
                                    plain
                                    :loading="is_post"
                                    @click="delSubmit(scope.row)"
                            >
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>


        <el-dialog
            title="添加用户组"
            :visible.sync="addDialog"
            width="30%"
        >
            <el-form ref="addForm" :model="addForm" :rules="rules" label-width="120px">
                <el-form-item label="用户组key" prop="name">
                    <el-input v-model="addForm.name" :maxlength="20" show-word-limit placeholder="请填写用户组key" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="用户组名称" prop="displayName">
                    <el-input v-model="addForm.displayName" placeholder="请填写用户组名称" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="用户组说明" prop="description">
                    <el-input
                        type="textarea"
                        placeholder="请输入身份组说明"
                        v-model="addForm.description"
                        maxlength="50"
                        show-word-limit
                    ></el-input>
                </el-form-item>
                <el-form-item label="是否启用">
                    <el-switch
                        v-model="addForm.isValid"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="启用"
                        inactive-text="禁用">
                    </el-switch>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="success" size="small" plain :loading="is_post" @click="addSubmit()">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog
            title="修改用户组"
            :visible.sync="editDialog"
            width="30%"
        >
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="120px">
                <el-form-item label="用户组key" prop="name">
                    <el-input v-model="editForm.name" :maxlength="20" show-word-limit placeholder="请填写用户组key" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="用户组名称" prop="displayName">
                    <el-input v-model="editForm.displayName" placeholder="请填写用户组名称" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="用户组说明" prop="description">
                    <el-input
                        type="textarea"
                        placeholder="请输入用户组说明"
                        v-model="editForm.description"
                        maxlength="50"
                        show-word-limit
                    ></el-input>
                </el-form-item>
                <el-form-item label="是否启用">
                    <el-switch
                        v-model="editForm.isValid"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="启用"
                        inactive-text="禁用">
                    </el-switch>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="success" size="small" plain :loading="is_post" @click="editSubmit()">提交修改</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </el-card>
</template>

<script>
    import request from '@/utils/request'
    import {stringTrim} from '@/utils/elvalid'

    export default {
        name: 'auth_role',
        data() {
            return {
                data: [],
                total: 0,
                is_post: false,
                is_ok: false,
                addForm:{
                    name:"",
                    displayName:"",
                    description:"",
                    isValid:false
                },
                rules:{
                    name:[
                        { required: true, message: '请输入身份组key', trigger: 'blur' },
                        { pattern:/^[a-z0-9_]{1,20}$/, message: '只支持小写字母,数字,下划线', trigger: 'blur' }
                    ],
                    displayName:[
                        { required: true, message: '请输入身份组名称', trigger: 'blur' },
                        {validator:stringTrim,trigger:"blur"},
                        { min:1,max:20, message: '最大支持20个字符', trigger: 'blur' }
                    ],
                    description:[
                        { min:0,max:50, message: '最大支持50个字符', trigger: 'blur' }
                    ]
                },
                selected:[],
                editForm:{
                    id:0,
                    name:"",
                    displayName:"",
                    description:"",
                    isValid:false
                },
                addDialog:false,
                editDialog:false,
                tableMaxHeight:0,
                showtable:false,
                allPermission0:[],
                allPermission1:[],
                allPermission2:[]
            }
        },
        methods: {
            handleSelectionChange(val) {
                this.selected = val;
            },
            init() {
                this.getAllPermission().then(()=>{
                    request.post('role/list').then(res => {
                        this.data = res.data;
                        this.is_ok = true
                    }).catch(err => {
                        this.is_ok = true
                        console.log(err)
                    })
                });
            },
            showCreateDialog(){
                this.addForm = {
                    name:"",
                    displayName:"",
                    description:"",
                    isValid:false
                };
                this.addDialog = true;
            },
            edit(item){
                this.editForm.description = item.description;
                this.editForm.name = item.name;
                this.editForm.displayName = item.displayName;
                this.editForm.id = item.id;
                this.editForm.isValid = item.isValid?true:false;
                this.editDialog = true;
            },
            addSubmit(){
                this.$refs.addForm.validate(valid=>{
                    if(!valid)return false;
                    this.is_post = true;
                    request.post("role/create",this.addForm).then(res=>{
                        this.data.push(res.data);
                        this.$message.success("添加身份组成功!");
                        this.addDialog = false;
                        this.is_post = false;
                    }).catch(err=>{
                        this.is_post = false;
                    });
                });
            },
            editSubmit(){
                this.$refs.editForm.validate(valid=>{
                    if(!valid)return false;
                    this.is_post = true;
                    request.post("role/edit",this.editForm).then(res=>{
                        for(let item of this.data){
                            if(item.id == this.editForm.id){
                                item.name = this.editForm.name;
                                item.displayName = this.editForm.displayName;
                                item.description = this.editForm.description;
                                item.isValid = this.editForm.isValid?1:0
                            }
                        }
                        this.editDialog = false;
                        this.$message.success("修改身份组成功!");
                        this.is_post = false;
                    }).catch(err=>{
                        this.is_post = false;
                    });
                });
            },
            //批量启用禁用
            changeMore(isValid){
                let ids = [];
                for(let item of this.selected){
                    ids.push(item.id);
                }
                this.is_post = true;
                request.post("role/change",{ids,isValid}).then(res=>{
                    for(let item of this.selected){
                        item.isValid = isValid;
                    }
                    this.$refs.table.clearSelection();
                    this.$message.success('批量'+(isValid?'启用':'禁用')+'操作执行成功!');
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            },
            //单个启用禁用
            change(item,isValid){
                let ids = [];
                ids.push(item.id);
                this.is_post = true;
                request.post("role/change",{ids,isValid}).then(res=>{
                    item.isValid = isValid;
                    this.$message.success((isValid?'启用':'禁用')+'操作执行成功!');
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            },
            //删除
            delSubmit(item){
                this.$confirm("此操作将删除该身份组,是否继续?","提示",{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(res=>{
                    this.is_post = true;
                    request.post("role/del",{id:item.id,isDelete:1}).then(res=>{
                        for(let i = 0;i<this.data.length;i++){
                            if(this.data[i].id == item.id){
                                this.data.splice(i,1);
                            }
                        }
                        this.$message.success("删除用户组操作成功!");
                        this.is_post = false;
                    }).catch(err=>{
                        this.is_post = false;
                    });
                });
            },
            makeTree(list,num = 0,data = []){
                for(let i = 0;i<list.length;i++){
                    if(num == 0){
                        if(list[i].parentId == 0){
                            let item = list.splice(i,1)[0];
                            data.push(item);
                            i--;
                        }
                    }else{
                        let item = this.selectTree(list[i].parentId,data)
                        if(item){
                            let it = list.splice(i,1)[0];
                            if(typeof item.children == "undefined"){
                                item.children = [];
                            }
                            item.children.push(it);
                            i--;
                        }
                    }
                }
                if(list.length == 0 || num > 10){
                    return data;
                }else{
                    return this.makeTree(list,++num,data);
                }
            },
            selectTree(id,list){
                let res = null;
                for(let item of list){
                    if(item.id == id){
                        return item;
                    }else if(item.children && item.children.length > 0){
                        res = this.selectTree(id,item.children);
                        if(res){
                            return res;
                        }
                    }
                }
                return res;
            },
            getAllPermission(){
                return new Promise((resolve, reject)=>{
                    request.post("permission/list",{type:"all",isValid:"all"}).then(res=>{
                        let data = this.makeTree(res.data);
                        for(let item of data){
                            if(item.type == 0){
                                this.allPermission0.push(item);
                                console.log(this.allPermission0,1111)
                            }else if(item.type == 1){
                                this.allPermission1.push(item);
                            }else if(item.type == 2){
                                this.allPermission2.push(item);
                            }
                        }
                        resolve();
                    }).catch(err=>{
                        reject(err);
                    });
                });
            },
            handleExpandChange(item){
                setTimeout(()=>{
                    let keys = [];
                    if(!this.$refs["tree0"]){
                        return false;
                    }
                    for(let it of item.permission){
                        keys.push(it.id);
                    }
                    this.$refs["tree0"].setCheckedKeys(keys);
                    this.$refs["tree1"].setCheckedKeys(keys);
                    this.$refs["tree2"].setCheckedKeys(keys);
                },80);
            },
            setPermission(item){
                let h = this.$refs["tree0"].getCheckedKeys();
                let app = this.$refs["tree1"].getCheckedKeys();
                let api = this.$refs["tree2"].getCheckedKeys();
                let arr = Array.from(new Set([...h, ...app,...api]));
                this.is_post = true;
                request.post("grant_perms",{permIds:arr,roleId:item.id}).then(res=>{
                    this.$message.success("设置权限成功!");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                    console.log(err);
                });
            }
        },
        created() {
            this.init()
        },
        mounted(){
            this.tableMaxHeight = this.$refs.card.$el.offsetHeight - 103;//143
            this.showtable = true;
        }
    }
</script>

<style scoped>

</style>
